import React, { useContext, useEffect, useState } from "react";
import map from "../../assets/images/omnamo/omnamo/map.png";
import faq2 from "../../assets/images/omnamo/faq2.png";
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import Breadcrumbs from "../Breadcrumb";
import { useNavigate } from "react-router-dom";
import "./TemplePage.css";
import ComingSoonModal from "../ComingSoonModal";
import {
  GetTempleCityList,
  GetTempleList,
} from "../../ApiServices/Temple/TempleApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
import DarshanBookingBannerImg from "../../assets/images/new/DarshanBookingBannerImg.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import TemplePageImage from "../../assets/images/new/TemplePageImage.png";

const TempleList = () => {
  const { setLoader, loader } = useContext(LoaderContext);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const navigate = useNavigate();
  const [TempleCityLst, setTempleCityLst] = useState([]);
  const [TempleLst, setTempleLst] = useState([]);
  const [DistrictID, setDistrictID] = useState(null);

  useEffect(() => {
    GetTempleCityListData();
  }, []);

  useEffect(() => {
    GetTempleListData(DistrictID);
  }, [DistrictID]);

  const GetTempleCityListData = async () => {
    setLoader(true);
    try {
      const response = await GetTempleCityList({
        START: 0,
        END: 100,
        WORD: "none",
      });

      if (response?.ResponseCode === "0") {
        const responseData = response?.DATA || [];
        setTempleCityLst(responseData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const GetTempleListData = async (districtId) => {
    setLoader(true);
    try {
      const response = await GetTempleList(districtId);
      if (response?.ResponseCode === "0") {
        const responseData = response?.DATA || [];
        setTempleLst(responseData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const handleCityClick = (districtId) => {
    setDistrictID(districtId);
  };

  const handleAllTemplesClick = () => {
    setDistrictID(null); // Set to null to fetch all temples
  };

  return (
    <>
      <section className="page-header mb-1">
        <div
          className="page-header__bg"
          style={{ backgroundImage: `url(${DarshanBookingBannerImg})` }}
        ></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">Temples</h2>
        </div>
      </section>
      <div className="container">
        <Breadcrumbs />
      </div>
      <section
        className="about-one about-one--about"
        style={{ padding: "0px 0 0px" }}
      >
        <div className="container">
          <div className="row g-0 align-items-start">
            <div className="col-xl-6 pe-0">
              <div
                className="about-one__image wow fadeInLeft temple-ImagesGrid"
                data-wow-delay="100ms"
                style={{ paddingBottom: '40px' }}
              >
                <div className="about-one__image__one" style={{ width: '95%' }} >
                  <img src={TemplePageImage} alt="careox" />
                </div>
              </div>
            </div>
            <div
              className="col-xl-6 ps-0 wow fadeInRight"
              data-wow-delay="200ms"
            >
              <div className="about-one__content">
                <div className="sec-title text-left">
                  <h1 className="sec-title__title bw-split-in-left">
                    Discover India’s Sacred Temples and Holy Pilgrimage Sites
                  </h1>
                </div>
                <ul className="about-one__content__list">
                  <li>
                    <span className="about-one__content__list__icon">
                      <i className="icofont-check-circled"></i>
                    </span>
                    Explore sacred sites rich in culture and ancient traditions.
                  </li>
                  <li>
                    <span className="about-one__content__list__icon">
                      <i className="icofont-check-circled"></i>
                    </span>
                    Find temples of beloved deities for spiritual connection.
                  </li>
                  <li>
                    <span className="about-one__content__list__icon">
                      <i className="icofont-check-circled"></i>
                    </span>
                    Plan pilgrimages with travel guides and festival details.
                  </li>
                </ul>
                <div className="d-flex justify-content-center ">
                  <button
                    className="careox-btn mx-3 buttons-in-mobile"
                    onClick={() => {
                      const section = document.getElementById("All");
                      if (section) {
                        const offset = 150; // Adjust scroll offset (e.g., for sticky header)
                        const topPos =
                          section.getBoundingClientRect().top +
                          window.pageYOffset -
                          offset;
                        window.scrollTo({ top: topPos, behavior: "smooth" });
                      }
                    }}
                  >
                    Explore Temples of India
                  </button>
                  <button
                    className="careox-btn mx-3"
                    style={{ padding: '8px 12px' }}
                    onClick={() => setShowComingSoon(true)}
                  >
                    + Add Temples
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>


      <div className="category-tabs-container " id="All">
        <ul className="nav justify-content-center border-bottom">
          <button
            className={`button ${DistrictID === null ? "is-checked" : ""}`}
            onClick={handleAllTemplesClick}
            style={{ fontSize: "medium" }}
          >
            <div className="btn-column" >
              {/* <img src={faq2} alt="All Temples Icon" /> */}
              <span>All</span>
            </div>
          </button>
          {TempleCityLst.map((filter, index) => (
            <button
              key={index}
              className={`button ${DistrictID === filter.DistrictID ? "is-checked" : ""
                }`} // Update this line
              onClick={() => handleCityClick(filter.DistrictID)}
              style={{ fontSize: "medium" }}
            >
              <div className="btn-column" >
                {/* <img src={faq2} alt={`${filter.name} Icon`} /> */}
                <span>{filter.DistrictName}</span>
              </div>
            </button>
          ))}
        </ul>
        <br></br>
        {/* Optional: filtered content placeholder */}
        {/* <div className="mt-3">
            Showing results for: <strong>{activeCategory}</strong>
          </div> */}
      </div>

      <div data-js="hero-demo " className="templeList">

        <ul className="grid ">
          {TempleLst?.length > 0 ? (
            TempleLst.map((val, index) => (
              <li
                key={index}
                className={`element-item cat-${val.category}`}
                data-category={`cat-${val.category}`}
                onClick={() =>
                  navigate(`/${val.TempleSlug}`, { state: { slug: val.TempleSlug } })
                }
                style={{ cursor: "pointer", height: '20em' }}
              >
                <div style={{ height: '20em' }}>
                  <img
                    src={val.TempleImage || faq2}
                    alt="gallery-img"
                  />
                  <div className="content-section">
                    <h5 className="text-title">{val.TempleName}</h5>
                    <p className="cardtext">{val.details}</p>
                  </div>
                </div>
              </li>
            ))
          ) : loader === false ? (
            <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4" style={{ width: '100%' }}>
              <img
                src={Batuk}
                alt="Empty Cart"
                className="img-fluid mb-3"
                style={{ maxWidth: "200px" }}
              />
              <h5 className="fw-bold" style={{ textAlign: "center" }}>
                No Temples available for this category
              </h5>
              <p className="text-muted">
                Please explore our other Cities.
              </p>
            </div>
          ) : null}


        </ul>
      </div>

      <ComingSoonModal
        show={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />
    </>
  );
};

export default TempleList;
